/* istanbul ignore file */
export * from './TilesSelection';
